import React from "react";
import StationPicker from "Components/OperatorSidePanel/components/Stations/StationPicker";
import {
  CurrentItemStyled,
  DropdownContentStyled,
  DropdownItemStyled,
  HeadingStyled,
  StationSelectionWrapperStyled,
  StationSelectorDropdownStyled,
} from "Components/StationView/components/StationPicker/styles";

/**
 * Wrapper component that uses the original StationPicker with custom styles and keyboard navigation
 */
export const StationPickerWithCustomStyles = () => {
  return (
    <StationPicker
      customStyles={{
        HeadingStyled,
        StationSelectionWrapperStyled,
        StationSelectorDropdownStyled,
        CurrentItemStyled,
        DropdownContentStyled,
        DropdownItemStyled,
      }}
      enableKeyboardNavigation={true}
    />
  );
};

export default StationPickerWithCustomStyles;
